/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/Event.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const Event: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 12 12" ref={ref} {...props}>
    <path
      fill={color}
      d="M3.848 1.2a.478.478 0 1 0-.957 0v.957h-.956C1.142 2.157.5 2.799.5 3.592V9.33c0 .793.642 1.435 1.435 1.435h2.87a.478.478 0 1 0 0-.957h-2.87a.48.48 0 0 1-.478-.478V5.505h8.608v1.889a.478.478 0 1 0 .957 0V3.592c0-.793-.642-1.435-1.435-1.435H8.63V1.2a.478.478 0 1 0-.956 0v.957H3.848zm6.217 3.348v-.956a.48.48 0 0 0-.478-.478H1.935a.48.48 0 0 0-.478.478v.956zM8.152 6.94c.264 0 .478.214.478.478v1.435h1.435a.478.478 0 0 1 0 .956H8.63v1.435a.478.478 0 0 1-.957 0V9.809H6.24a.478.478 0 0 1 0-.956h1.434V7.418c0-.264.215-.478.479-.478"
    />
  </svg>
);
Event.displayName = "Event";
